<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="visibleNavMenuItems" />
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import navMenuItems from '@/navigation/horizontal'
import authStore from '@/services/authStore'
import { filterNavItemsByUserType } from '@/helpers/nav-filter'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
  components: {
    HorizontalNavMenuItems,
  },
  setup() {
    // Report entries are shown to admin and interno only; evaluated here so the menu follows login and logout
    const { userType } = authStore()
    const visibleNavMenuItems = computed(() => filterNavItemsByUserType(navMenuItems, userType.value))

    return {
      visibleNavMenuItems,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
